import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { TitleText } from '@calendly/ui/components/typography'

import { PanelContentContainer } from '../styles'
import { ConfirmationPageTypeField } from './confirmation_page_type_field'
import { ExternalSection } from './external_section'
import { InternalSection } from './internal_section'
import { LockedExternalSection } from './locked_external_section'
import { LockedInternalSection } from './locked_internal_section'


const ConfirmationPageLocked = () => {
  const { values: { confirmationPageType } } = useFormContext()

  return (
    <PanelContentContainer>
      <TitleText size="x-small" level={3}>
        {I18n.t('publisher.event_type_editor.sections.booking_page_options.confirmation_page.after_booking')}
      </TitleText>
      {confirmationPageType === 'internal' && <LockedInternalSection />}
      {confirmationPageType === 'external' && <LockedExternalSection />}
    </PanelContentContainer>
  )
}

const ConfirmationPageSection = () => {
  const { values: { confirmationPageType } } = useFormContext()

  return (
    <PanelContentContainer>
      <ConfirmationPageTypeField />
      {confirmationPageType === 'internal' && <InternalSection />}
      {confirmationPageType === 'external' && <ExternalSection />}
    </PanelContentContainer>
  )
}

export const ConfirmationPage = ({ isLocked }) => (
  !isLocked ? <ConfirmationPageSection /> : <ConfirmationPageLocked />
)
